// Shared stub for routes not yet built out. Each real page replaces its
// Placeholder usage in a later build step (see the plan's Build order).
export default function Placeholder({ title, note }) {
  return (
    <div className="sv-container sv-page-top sv-page-bottom" style={{ textAlign: 'center' }}>
      <h1 style={{ fontSize: '1.6rem', fontWeight: 900, marginBottom: 10 }}>{title}</h1>
      <p style={{ color: 'var(--text-muted)' }}>{note}</p>
    </div>
  );
}
